<template>
  <div v-if="userAuth.uid !== userProfile.email">
    <div class="alert alert-warning" role="alert">
      <div class="notification-icon">
        <img src="../assets/warning-icon.svg" />
      </div>
      <div class="notification-content">
        <p>
          You're impersonating
          {{ userProfile.fullName ? userProfile.fullName : userProfile.email }}.
        </p>
        <p>This warning will keep showing until impersonating session ends.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ImpersonateNotification',
  computed: {
    ...mapState({
      userProfile: state => state.profile.user,
      userAuth: state => state.auth.auth
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.alert {
  width: 40%;
  border: 0;
  padding: 20px;
  border-radius: 4px;
  text-align: left;
  display: flex;
  align-content: center;
  border: 1px solid black;
}

.alert-warning {
  background-color: #fefcf1;
  color: #25282a;
}

.notification-content {
  font-family: $inter;
}

.notification-icon {
  padding-right: 15px;
}
</style>
